import { sectionType } from "../../../../sectionType"
import { segmentType } from "../../Corridor/models/segment-type"
import { ColumnDefinition, inclusionEnum, SegmentDefinition } from "../../models/ColumnDefinition/column-definition"
import { columnType } from "./column-type.enum"
import { headType } from "./head-type.enum"

export enum variantEnum { single = 'single', left = 'left', right = 'right' };
export enum subtypeEnum { single = 'single', C = 'C' };
export enum columnSubtype { moosplaza = 'moosplaza', body = 'body', head = 'head', corridor = 'corridor' };


const threeBayPlinthDef: SegmentDefinition<segmentType, variantEnum, subtypeEnum> =
{
    type: segmentType.plinth,
    subtype: subtypeEnum.C,
    floorVariants: [{
        floors: 1,
        variants: [{
            variant: variantEnum.left,
            sections: [sectionType.V_P32_R]
        }, {
            variant: variantEnum.right,
            sections: [sectionType.V_P31_R]
        },]
    },
    {
        floors: 2,
        variants: [{
            variant: variantEnum.left,
            sections: [sectionType.V_P322_R]
        }, {
            variant: variantEnum.right,
            sections: [sectionType.V_P312_R]
        },]
    }]
};

const fourBayPlinthDef: SegmentDefinition<segmentType, variantEnum, subtypeEnum>  = {
    type: segmentType.plinth,
    subtype: subtypeEnum.C,
    floorVariants: [{
        floors: 1,
        variants: [{
            variant: variantEnum.left,
            sections: [sectionType.V_P42_R]
        }, {
            variant: variantEnum.right,
            sections: [sectionType.V_P41_R]
        },]
    },
    {
        floors: 2,
        variants: [{
            variant: variantEnum.left,
            sections: [sectionType.V_P422_R]
        }, {
            variant: variantEnum.right,
            sections: [sectionType.V_P412_R]
        },]
    }]
}

const fiveBayPlinthDef: SegmentDefinition<segmentType, variantEnum, subtypeEnum>  =
{
    type: segmentType.plinth,
    subtype: subtypeEnum.C,
    floorVariants: [{
        floors: 1,
        variants: [{
            variant: variantEnum.left,
            sections: [sectionType.V_P52_R]
        }, {
            variant: variantEnum.right,
            sections: [sectionType.V_P51_R]
        },]
    },
    {
        floors: 2,
        variants: [{
            variant: variantEnum.left,
            sections: [sectionType.V_P522_R]
        }, {
            variant: variantEnum.right,
            sections: [sectionType.V_P512_R]
        },]
    }]
};

export const columnDefs: ColumnDefinition<columnType | headType, subtypeEnum, segmentType, variantEnum, columnSubtype>[] =
    [
        {
            type: columnType.V_P32C_C_M,
            bays: 3,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [inclusionEnum.staircase, inclusionEnum.elevator],
            segmentDefinitions: [
                threeBayPlinthDef,
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.C_M_O_TL]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TL_C_M]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.C_MK_O_TLK]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLK_C_MK]
                        }],
                       
                    }],

                }
            ]
        },
        {
            type: columnType.V_P32C_2C_XS,
            bays: 3,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [inclusionEnum.staircase, inclusionEnum.elevator],
            segmentDefinitions: [
                threeBayPlinthDef,
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_XS_O_TL]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TL_2C_XS]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_XSK_O_TLK]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLK_2C_XSK]
                        }],
                    }],
                }
            ]
        },
        {
            type: columnType.V_P3C_C_L,
            bays: 3,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [inclusionEnum.staircase],
            segmentDefinitions: [
                threeBayPlinthDef,
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.C_L_O_T_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.C_L_O_T_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.C_LK_O_T_R]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.C_LK_O_T_R]
                        }],
                    }],
                }
            ]
        },
        {
            type: columnType.V_P4C_C_L_C_XS,
            bays: 4,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [],
            segmentDefinitions: [
                fourBayPlinthDef,
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.C_L_C_XS]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.C_L_C_XS]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.C_LK_C_XSK]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.C_LK_C_XSK]
                        }],
                    }],
                }
            ]
        },
        {
            type: columnType.V_P42C_C_XS_C_M,
            bays: 4,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [inclusionEnum.staircase, inclusionEnum.elevator],
            segmentDefinitions: [
                fourBayPlinthDef,
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.C_XS_C_M_O_TL]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TL_C_XS_C_M]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.C_XSK_C_MK_O_TLK]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLK_C_XSK_C_MK]
                        }],
                    }],

                }
            ]
        },
        {
            type: columnType.V_P42C_3C_XS,
            bays: 4,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [inclusionEnum.staircase, inclusionEnum.elevator],
            segmentDefinitions: [
                fourBayPlinthDef,
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._3C_XS_O_TL]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TL_3C_XS]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._3C_XSK_O_TLK]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLK_3C_XSK]
                        }],
                    }],
                }
            ]
        },
        {
            type: columnType.V_P42C_C_XL,
            bays: 4,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [inclusionEnum.staircase, inclusionEnum.elevator],
            segmentDefinitions: [
                fourBayPlinthDef,
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.C_XL_O_TL]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TL_C_XL]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.C_XLK_O_TLK]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLK_C_XLK]
                        }],
                    }],
                }
            ]
        },
        {
            type: columnType.V_P42_S1S2,
            bays: 4,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [inclusionEnum.staircase, inclusionEnum.elevator],
            segmentDefinitions: [
                fourBayPlinthDef,
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.C_S1S2_O_TL]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TL_C_S1S2]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.C_S1S2K_O_TLK]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLK_C_S1S2K]
                        }],
                    }],

                }
            ]
        },
        {
            type: columnType.V_P52C_4C_XS,
            bays: 5,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [inclusionEnum.staircase, inclusionEnum.elevator],
            segmentDefinitions: [
                fiveBayPlinthDef,
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._4C_XS_O_TL]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TL_4C_XS]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._4C_XSK_O_TLK]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLK_4C_XSK]
                        }],
                    }],
                }
            ]
        },
        {
            type: columnType.V_P52C_C_XS_C_M,
            bays: 5,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [inclusionEnum.staircase, inclusionEnum.elevator],
            segmentDefinitions: [
                fiveBayPlinthDef,
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_XS_C_M_O_TL]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TL_2C_XS_C_M]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_XSK_C_MK_O_TLK]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLK_2C_XSK_C_MK]
                        }],
                    }],
                }
            ]
        },
        {
            type: columnType.V_P52C_2C_M,
            bays: 5,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [inclusionEnum.staircase, inclusionEnum.elevator],
            segmentDefinitions: [
                fiveBayPlinthDef,
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_M_O_TL]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TL_2C_M]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_MK_O_TLK]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.O_TLK_2C_MK]
                        }],
                      
                    }],
                }
            ]
        },
        {
            type: columnType.V_P5C_C_L_C_M,
            bays: 5,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [],
            segmentDefinitions: [
                fiveBayPlinthDef,
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.C_L_C_M]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.C_L_C_M]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.C_LK_C_MK]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.C_LK_C_MK]
                        }],
                    }],
                }
            ]
        },
        {
            type: columnType.V_P5C_C_L_C_XS,
            bays: 5,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [],
            segmentDefinitions: [
                fiveBayPlinthDef,
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.C_L_2C_XS]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.C_L_2C_XS]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.C_LK_2C_XSK]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType.C_LK_2C_XSK]
                        }],
                    }],
                }
            ]
        },
        {
            type: columnType.V_P52C_C_XS_2C_S,
            bays: 5,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [inclusionEnum.staircase, inclusionEnum.elevator],
            segmentDefinitions: [
                fiveBayPlinthDef,
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.O_TL_C_XS_C_S1S2]
                        },
                        {
                            variant: variantEnum.right,
                            sections: [sectionType.C_XS_C_S1S2_O_TL]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.O_TLK_C_XSK_C_S1S2K]
                        },
                        {
                            variant: variantEnum.right,
                            sections: [sectionType.C_XSK_C_S1S2K_O_TLK]
                        }],
                    }]
                },
            ]
        },
        {
            type: columnType.V_P52C_C_XS_C_XL,
            bays: 5,
            columnSubtypes: [columnSubtype.moosplaza],
            inclusions: [inclusionEnum.staircase, inclusionEnum.elevator],
            segmentDefinitions: [
                fiveBayPlinthDef,
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.O_TL_C_XL_C_XS]
                        },
                        {
                            variant: variantEnum.right,
                            sections: [sectionType.C_XS_C_XL_O_TL]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType.O_TLK_C_XLK_C_XSK]
                        },
                        {
                            variant: variantEnum.right,
                            sections: [sectionType.C_XSK_C_XLK_O_TLK]
                        }],
                    }]
                },
            ]
        }, {
            type: columnType.C_L,
            bays: 3,
            columnSubtypes: [columnSubtype.body],
            inclusions: [inclusionEnum.staircase],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_LBG_O_T_R]
                        }],
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_LBG_O_T2_R]
                        }],
                    }],
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_L_O_T_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_LK_O_T_R]
                        }],
                    }],
                }
            ]
        }, {
            type: columnType.C_XL,
            bays: 3,
            columnSubtypes: [columnSubtype.body],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XLBG_R]
                        }],
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XLBG2_R]
                        }],
                    }],
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XL_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XLK_R]
                        }],
                    }],
                }
            ]
        }, {
            type: columnType.C_XS,
            bays: 1,
            columnSubtypes: [columnSubtype.body],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XSBG_R]
                        }],
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XSBG2_R]
                        }],
                    }],
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XS_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_XSK_R]
                        }],
                    }],
                }
            ]
        }, {
            type: columnType.C_M,
            bays: 2,
            columnSubtypes: [columnSubtype.body],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_MBG_R]
                        }],
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_MBG2_R]
                        }],
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_M_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_MK_R]
                        }],
                    }],
                }
            ]
        }, {
            type: columnType.C_S1S2,
            bays: 3,
            columnSubtypes: [columnSubtype.body],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_S1S2BG_R]
                        }],
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_S1S2BG2_R]
                        }],
                    }],

                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_S1S2_R]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.C_S1S2K_R]
                        }],
                    }],
                }
            ]
        },
        {
            type: headType._2C_XL,
            bays: 3,
            columnSubtypes: [columnSubtype.head],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_XLBG_1]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType._2C_XLBG_2]
                        }],
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_XLBG2_1]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType._2C_XLBG2_2]
                        }],
                    }],

                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_XL_1]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType._2C_XL_2]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_XLK_1]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType._2C_XLK_2]
                        }],
                    }],
                }
            ]
        },

        {
            type: headType._2C_S1S2,
            bays: 6,
            columnSubtypes: [columnSubtype.head],
            inclusions: [],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_S1S2BG_1]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType._2C_S1S2BG_2]
                        }],
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_S1S2BG2_1]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType._2C_S1S2BG2_2]
                        }],
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_S1S2_1]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType._2C_S1S2_2]
                        }],
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.C,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.left,
                            sections: [sectionType._2C_S1S2K_1]
                        }, {
                            variant: variantEnum.right,
                            sections: [sectionType._2C_S1S2K_2]
                        }],
                    }],

                }
            ]
        },
        {
            type: columnType.O_TL,
            bays: 1,
            uiName: 'lift',
            columnSubtypes: [columnSubtype.body],
            inclusions: [inclusionEnum.elevator, inclusionEnum.staircase],
            segmentDefinitions: [
                {
                    type: segmentType.plinth,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.O_TLBG_R]
                        }]
                    }, {
                        floors: 2,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.O_TLBG_R] // TODO 2 floor variant needs to be implemented
                        }]
                    }]
                },
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.O_TL_R]
                        }]
                    }]
                },
                {
                    type: segmentType.crown,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.O_TLK_R]
                        }]
                    }],

                }
            ]
        },
        {
            type: columnType.Corridor,
            columnSubtypes: [columnSubtype.corridor],
            inclusions: [inclusionEnum.elevator, inclusionEnum.staircase],
            segmentDefinitions: [
                {
                    type: segmentType.middle,
                    subtype: subtypeEnum.single,
                    floorVariants: [{
                        floors: 1,
                        variants: [{
                            variant: variantEnum.single,
                            sections: [sectionType.O_TL_R]
                        }]
                    }]
                },
            ]
        },
    ];
